"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailureResponse = exports.SuccessResponse = exports.RequestParameters = exports.ExtraComputation = exports.LocationTypeSetFromString = exports.ResultTypeSetFromString = exports.Region = exports.Language = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../schema");
const common_1 = require("../../common");
const common_2 = require("../common");
const error_1 = require("../error");
const NAMESPACE = 'Google.Geocode.Reverse.Http';
exports.Language = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[a-z]{2}(-\w{2,4})?$/)).annotations({
    identifier: `${NAMESPACE}.Language`,
    documentation: 'https://developers.google.com/maps/faq#languagesupport',
});
exports.Region = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[a-z]{2}$/)).annotations({
    identifier: `${NAMESPACE}.Region`,
    description: 'Two-character ccTLD (top-level domain)',
});
exports.ResultTypeSetFromString = (0, schema_1.makeNonEmptySetFromSplitString)(common_2.AddressType, '|').annotations({
    identifier: `${NAMESPACE}.ResultTypeSetFromString`,
});
exports.LocationTypeSetFromString = (0, schema_1.makeNonEmptySetFromSplitString)(common_2.LocationType, '|').annotations({
    identifier: `${NAMESPACE}.LocationTypeSetFromString`,
});
exports.ExtraComputation = effect_1.Schema.Literal(
/**
 * See: https://developers.google.com/maps/documentation/geocoding/guides-v3/address-descriptors/requests-address-descriptors
 */
'ADDRESS_DESCRIPTORS', 
/**
 * See: https://developers.google.com/maps/documentation/geocoding/guides-v3/building-attributes
 */
'BUILDING_AND_ENTRANCES').annotations({
    identifier: `${NAMESPACE}.ExtraComputation`,
});
exports.RequestParameters = effect_1.Schema.Struct({
    apiKey: (0, effect_1.pipe)(common_1.ApiKey, effect_1.Schema.propertySignature, effect_1.Schema.fromKey('key')),
    geoPosition: (0, effect_1.pipe)(common_1.GeoPositionFromLatLngString, effect_1.Schema.propertySignature, effect_1.Schema.fromKey('latlng')),
    /** Optional properties */
    language: (0, effect_1.pipe)(exports.Language, effect_1.Schema.optionalWith({ exact: true, as: 'Option' }), effect_1.Schema.withConstructorDefault(effect_1.Option.none)),
    region: (0, effect_1.pipe)(exports.Region, effect_1.Schema.optionalWith({ exact: true, as: 'Option' }), effect_1.Schema.withConstructorDefault(effect_1.Option.none)),
    resultTypes: (0, effect_1.pipe)(exports.ResultTypeSetFromString, effect_1.Schema.optionalWith({ exact: true, as: 'Option' }), effect_1.Schema.fromKey('result_type'), effect_1.Schema.withConstructorDefault(effect_1.Option.none)),
    locationTypes: (0, effect_1.pipe)(exports.LocationTypeSetFromString, effect_1.Schema.optionalWith({ exact: true, as: 'Option' }), effect_1.Schema.fromKey('location_type'), effect_1.Schema.withConstructorDefault(effect_1.Option.none)),
    extraComputations: (0, effect_1.pipe)(effect_1.Schema.Set(exports.ExtraComputation), effect_1.Schema.optionalWith({ exact: true, as: 'Option' }), effect_1.Schema.fromKey('extra_computations'), effect_1.Schema.withConstructorDefault(effect_1.Option.none)),
}).annotations({
    identifier: `${NAMESPACE}.RequestParameters`,
    documentation: 'https://developers.google.com/maps/documentation/geocoding/guides-v3/requests-reverse-geocoding#reverse-requests',
});
exports.SuccessResponse = effect_1.Schema.Struct({
    status: effect_1.Schema.tag('OK'),
    results: effect_1.Schema.NonEmptyArray(common_2.Result),
}).annotations({
    identifier: `${NAMESPACE}.SuccessResponse`,
    documentation: 'https://developers.google.com/maps/documentation/geocoding/guides-v3/requests-geocoding#GeocodingResponses',
});
exports.FailureResponse = effect_1.Schema.Struct({
    status: error_1.FailureStatus,
    errorMessage: (0, effect_1.pipe)(effect_1.Schema.String, effect_1.Schema.optional, effect_1.Schema.fromKey('error_message')),
}).annotations({
    identifier: `${NAMESPACE}.FailureResponse`,
    documentation: 'https://developers.google.com/maps/documentation/geocoding/guides-v3/requests-geocoding#StatusCodes',
});
//# sourceMappingURL=http.js.map